import AxiosBase from "@services/middlewares/AxiosBase";
import Vue from 'vue';

export default function ({next}) {
  const app = new Vue;
  app.$store.commit('setting/setAuthType', 'adminAuth')
  return AxiosBase({next, authKey: 'adminAuth'})
}
